// Recipe Match — turns Food Preferences (Love / Avoid) into ingredient keyword checks.
// Each keyword can skip matches preceded by certain words (e.g. "sweet" before "potato").
const MILK_NOT = ['almond', 'coconut', 'oat', 'rice', 'nut', 'hemp', 'cashew'];
const BUTTER_NOT = ['nut', 'almond', 'peanut', 'cashew', 'sunflower', 'seed', 'cocoa', 'apple', 'coconut', 'shea'];

const OVERRIDES = {
  'Artichoke (common & Jerusalem)': ['artichoke'],
  'Green & string beans': ['green bean', 'string bean'],
  'Cabbage (red, green, napa)': ['cabbage'],
  'Onions (all, incl. leeks)': ['onion', 'leek', 'shallot', 'scallion'],
  'Radishes (red & daikon)': ['radish', 'daikon'],
  'Leaf lettuce (red & green)': ['lettuce'],
  'Mixed / mesclun greens': ['mixed greens', 'mesclun', 'salad greens'],
  'Seaweed / dulse': ['seaweed', 'dulse', 'nori', 'kelp'],
  'Green peas': ['green pea', { kw: 'peas', not: ['snow', 'snap', 'chick'] }],
  'Sweet potato': ['sweet potato', 'yam'],
  'Grass-fed beef': ['beef'],
  'Wild salmon': ['salmon'],
  'White fish (cod / haddock)': ['white fish', 'cod', 'haddock', 'halibut'],
  'Macadamia nuts': ['macadamia'],
  'Pumpkin seeds': ['pumpkin seed', 'pepita'],
  'Sunflower seeds': ['sunflower seed'],
  'Sesame seeds / tahini': ['sesame', 'tahini'],
  'Chia seeds': ['chia'],
  'Flax seeds': ['flax'],
  'Hemp seeds': ['hemp'],
  'Nut butters': ['nut butter', 'almond butter', 'peanut butter', 'cashew butter'],
  Olives: [{ kw: 'olive', notAfter: ['oil'] }],
  'Coconut / coconut oil': ['coconut'],
  'Butter / ghee': ['ghee', { kw: 'butter', not: BUTTER_NOT }],
  'Tallow / duck fat': ['tallow', 'duck fat'],
  'White rice': ['white rice', 'jasmine rice', 'basmati'],
  Oats: [{ kw: 'oat', notAfter: ['milk'] }],
  'Gluten-free pasta': ['pasta', 'noodle'],
  'Sourdough bread': ['sourdough', 'bread'],
  Potatoes: [{ kw: 'potato', not: ['sweet'] }],
  "Cow's milk": [{ kw: 'milk', not: MILK_NOT }, 'heavy cream'],
  'Goat milk / cheese': ['goat milk', 'goat cheese', 'feta', 'chevre'],
  'Hard cheese': ['parmesan', 'cheddar', 'pecorino', 'hard cheese', 'manchego'],
  'Yogurt / kefir': ['yogurt', 'yoghurt', 'kefir'],
  'Bok choy': ['bok choy', 'pak choi'],
};

const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const stem = (w) => (/[^su]s$/.test(w) ? w.slice(0, -1) : w);

const keywordsFor = (food) => OVERRIDES[food]
  || food.replace(/\(.*?\)/g, '').toLowerCase().split('/').map((p) => stem(p.trim())).filter(Boolean);

const hit = (text, k) => {
  const { kw, not = [], notAfter = [] } = typeof k === 'string' ? { kw: k } : k;
  const re = new RegExp(`\\b${esc(kw)}(?:e?s)?\\b`, 'g');
  let m;
  while ((m = re.exec(text))) {
    const before = text.slice(0, m.index).trim().split(/\s+/).pop() || '';
    const after = text.slice(m.index + m[0].length).trim().split(/\s+/)[0] || '';
    if (!not.includes(before) && !notAfter.includes(after)) return true;
  }
  return false;
};

export const matchRecipe = (recipe, love = [], avoid = []) => {
  const text = (recipe.ingredients || []).join(' \n ').toLowerCase().replace(/[’']/g, "'");
  const found = (foods) => foods.filter((f) => keywordsFor(f).some((k) => hit(text, k)));
  return { loved: found(love), avoided: found(avoid) };
};

// Short display name: "Onions (all, incl. leeks)" -> "Onions"
export const shortFood = (f) => f.replace(/\s*\(.*?\)/g, '');
